
//@ts-nocheck
import "./utils/telegram-web-app"
import Eventemitter3 from "eventemitter3"
import axios from "axios";

import { EvmErrorCode } from "./EvmErrorCode"
import { createAbortController } from "./utils/create-abort-controller"
import { tgUtils } from "./utils/utils"


import { type Account, type RequestArguments, type JsonRpcResponse, ALLIANCE, SwitchEthereumChainParams, initOptions, Web3Provider } from "./types"
import { messages, errorCodes, rpcErrors } from "./message";
import { getSiteMetadata, getSyncSiteMetadata } from "./metaData"
import { vaildatorEIP712, resemblesEvmAddress } from "./utils/validator"
import { AppInfo, BASE_URL } from "./constant"


import * as uuid from "uuid";


import { EthereumProvider, TronLinkProvider } from "./provider/index"



export class WalletTgSdk extends Eventemitter3 {
    version = AppInfo.version
    ethereum: EthereumProvider
    // tronLink: TronLinkProvider
    getAppInfo = () => {
        return {
            ...AppInfo
        }
    }
    constructor(options?: initOptions) {

        super()


        const metaData = options?.metaData

        this.connectUrl = options?.connect || BASE_URL.connect
        this.bridgeUrl = options?.bridge || BASE_URL.bridge
        this.connect_direct_link = options?.connect_direct_link || BASE_URL.connect_direct_link


        this.injected = options?.injected || false

        this.metaData = {
            icon: metaData?.icon,

            name: metaData?.name,
            url: metaData?.url,

            direct_link: metaData?.direct_link,

            description: metaData?.description

        }



        this._initialize()


    }
    _initialize() {
        //initialize provider
        this.ethereum = new EthereumProvider({
            connect: this.connectUrl,
            bridge: this.bridgeUrl,
            connect_direct_link: this.connect_direct_link,
            metaData: this.metaData
        })
        // this.tronLink = new TronLinkProvider({
        //     connect: this.connectUrl,
        //     bridge: this.bridgeUrl,
        //     connect_direct_link: this.connect_direct_link,
        //     metaData: this.metaData
        // })
        if (this.injected) {
            if (!window.ethereum) {
                window.ethereum = this.ethereum
                dispatchEvent(new Event("ethereum#initialized"))
            }
            // if (!window.tronLink) {
            //     window.tronLink = this.tronLink
            //     dispatchEvent(new Event("tronlink#initialized"))
            // }

        }
        this.emit("_initialized")
    }

}





export default {
    WalletTgSdk
}